import { Injectable } from '@angular/core';

import { Oauth2Service } from '@bytel/checkout';

import { ReferrerService } from '@base/common/services/referrer.service';

import { Observable, of } from 'rxjs';

import { StorageService } from './../common/services/storage.service';
import { ConfigurationService } from './../services/configuration.service';

export const YAMA_STORAGE_KEY: string = 'yama_cart';
@Injectable({
    providedIn: 'root',
})
export class ReferrerResolver {
    constructor(
        private oAuth2Service: Oauth2Service,
        private configurationService: ConfigurationService,
        private referrerService: ReferrerService,
        private storageService: StorageService,
    ) {}

    public resolve(): Observable<any> {
        if (!this.storageService.get(YAMA_STORAGE_KEY, false)) {
            this._handleYamaReferrers();
        }

        return of(null);
    }

    private _handleYamaReferrers(): void {
        const yamaReferrers: string[] = this.configurationService.getData()?.global.yama?.referrers || [];
        if (this.referrerService.isReferrerValid(yamaReferrers)) {
            const dayMilliseconds: number = 3600 * 36 * 1000;
            const expirationDate: number = new Date().getTime() + dayMilliseconds;
            this.storageService.set(YAMA_STORAGE_KEY, true, false, expirationDate);
            if (this.oAuth2Service.loggedPicasso()) {
                this.oAuth2Service.logout();
            }
        }
    }
}
